<template>
  <v-container fluid>
<!--    <v-tabs>-->
<!--&lt;!&ndash;      <v-tab>All</v-tab>&ndash;&gt;-->
<!--      <div class="ms-auto">-->
<!--        <v-btn class="mr-5" elevation="0" color="primary" outlined @click="fetchData()">Refresh</v-btn>-->
<!--&lt;!&ndash;        <v-btn class="mr-5" elevation="0" color="primary" text disabled>Manage Tabs</v-btn>&ndash;&gt;-->
<!--&lt;!&ndash;        <v-btn class="mr-5" elevation="0" color="primary" text disabled>Actions</v-btn>&ndash;&gt;-->
<!--      </div>-->
<!--    </v-tabs>-->
    <v-divider/>
    <v-card class="mt-5" elevation="0">
      <v-card-text>
        <v-row class="align-center">
          <v-col cols="12" lg="10" class="d-flex flex-wrap flex-lg-nowrap">
            <v-text-field class="me-lg-3" label="Filter monitoring items" prepend-inner-icon="fa-search" v-model="filter.search" clearable dense solo-inverted/>
            <v-text-field class="me-lg-3" label="City" v-model="filter.tariffZone" clearable dense solo-inverted/>
            <v-menu v-model="menuPickerStart" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on, attrs }">
                <v-datetime-picker label="Date Start" v-bind="attrs" v-on="on" v-model="filter.datePickerStart" date-format="dd/MM/yyyy" :textFieldProps="{dense: true, soloInverted: true, class: ['me-lg-3']}" :timePickerProps="{format: '24hr'}">
                  <template v-slot:dateIcon>
                    <v-icon>fa-calendar</v-icon>
                  </template>
                  <template v-slot:timeIcon>
                    <v-icon>fa-clock</v-icon>
                  </template>
                </v-datetime-picker>
              </template>
            </v-menu>
            <v-menu v-model="menuPickerEnd" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on, attrs }">
                <v-datetime-picker label="Date End" v-bind="attrs" v-on="on" v-model="filter.datePickerEnd" date-format="dd/MM/yyyy" :textFieldProps="{dense: true, soloInverted: true, class: ['me-lg-3']}" :timePickerProps="{format: '24hr'}">
                  <template v-slot:dateIcon>
                    <v-icon>fa-calendar</v-icon>
                  </template>
                  <template v-slot:timeIcon>
                    <v-icon>fa-clock</v-icon>
                  </template>
                </v-datetime-picker>
              </template>
            </v-menu>
            <v-autocomplete class="me-lg-3" label="Status" v-model="filter.statuses" :items="statuses" :color="changeColorFilter(filter.statuses)" :class="changeColorFilter(filter.statuses)" hide-details multiple clearable dense solo-inverted>
              <template v-slot:selection="{ item, index }">
                <template v-if="index < 1">
                  <span>{{ item.text }}</span>
                </template>
                <span v-if="index === 1" class="black--text caption">&nbsp;(+{{ filter.statuses.length - 1 }} others)</span>
              </template>
            </v-autocomplete>
            <v-autocomplete class="me-lg-3" label="User type" v-model="filter.userTypes" :items="userTypes" :color="changeColorFilter(filter.userTypes)" :class="changeColorFilter(filter.userTypes)" hide-details clearable dense solo-inverted>
              <template v-slot:selection="{ item, index }">
                <template v-if="index < 1">
                  <span>{{ item.text }}</span>
                </template>
                <span v-if="index === 1" class="black--text caption">&nbsp;(+{{ filter.userTypes.length - 1 }} others)</span>
              </template>
            </v-autocomplete>
            <v-autocomplete class="me-lg-3" label="Ride type" v-model="filter.rideTypes" :color="changeColorFilter(filter.rideTypes)" :class="changeColorFilter(filter.rideTypes)" hide-details disabled multiple clearable dense solo-inverted>
              <template v-slot:selection="{ item, index }">
                <template v-if="index < 1">
                  <span>{{ item.text }}</span>
                </template>
                <span v-if="index === 1" class="black--text caption">&nbsp;(+{{ filter.rideTypes.length - 1 }} others)</span>
              </template>
            </v-autocomplete>
            <v-autocomplete class="me-lg-3" label="Class" v-model="filter.classes" :items="classes" :color="changeColorFilter(filter.classes)" :class="changeColorFilter(filter.classes)" hide-details multiple clearable dense solo-inverted>
              <template v-slot:selection="{ item, index }">
                <template v-if="index < 1">
                  <span>{{ item.text }}</span>
                </template>
                <span v-if="index === 1" class="black--text caption">&nbsp;(+{{ filter.classes.length - 1 }} others)</span>
              </template>
            </v-autocomplete>
            <v-autocomplete class="me-lg-3" label="Company" v-model="filter.legalEntities" :color="changeColorFilter(filter.legalEntities)" :class="changeColorFilter(filter.legalEntities)" hide-details disabled multiple clearable dense solo-inverted>
              <template v-slot:selection="{ item, index }">
                <template v-if="index < 1">
                  <span>{{ item.text }}</span>
                </template>
                <span v-if="index === 1" class="black--text caption">&nbsp;(+{{ filter.legalEntities.length - 1 }} others)</span>
              </template>
            </v-autocomplete>
            <v-text-field class="me-lg-3" label="Address point a" prepend-inner-icon="fa-search" v-model="filter.addressPointA" clearable dense solo-inverted/>
            <v-text-field class="me-lg-3" label="Address point b" prepend-inner-icon="fa-search" v-model="filter.addressPointB" clearable dense solo-inverted/>
            <v-text-field class="me-lg-3" label="Vehicle plates" prepend-inner-icon="fa-search" v-model="filter.vehiclePlates" clearable dense solo-inverted/>
            <v-text-field class="me-lg-3" label="Driver" prepend-inner-icon="fa-search" v-model="filter.driver" clearable dense solo-inverted/>
          </v-col>
          <v-col cols="12" lg="2" class="d-flex align-center justify-lg-end mb-5">
<!--            <upload-button v-if="$store.state.auth.user.role === 'aggregator'" :on-file-change="onAgentDiscountFileChoice" :loading="agentDiscountUploading" accept=".xls,.xlsx" outlined class="mr-2 text-none" >-->
<!--              <i class="fas fa-upload"></i>-->
<!--            </upload-button>-->
            <v-dialog v-model="dialogPickerHeaders" width="500" dark>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-2" elevation="0" color="primary" outlined v-bind="attrs" v-on="on"><i class="fas fa-sliders-h"></i></v-btn>
              </template>
              <v-card>
                <v-card-title class="text-h5 ">Header columns</v-card-title>
                <v-card-text class="py-5">
                  <v-select v-model="selectedHeaders" :items="headers" label="Select Columns" multiple outlined return-object>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 3">
                        <span>{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 3" class="grey--text caption">&nbsp;(+{{ selectedHeaders.length - 3 }} others)</span>
                    </template>
                  </v-select>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogPickerHeaders = false">I accept</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn :loading="reportLoading" class="mr-2" elevation="0" outlined @click="callInitiateCsvReport">
              <span>CSV</span>
              <i class="fas fa-download"></i>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      class="elevation-0"
      :loading="loading"
      :headers="showHeaders"
      :items="collection"
      :pageCount="numberOfPages"
      :server-items-length="totalCollection"
      :options.sync="options"
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 100, 200]
      }"
    >
      <template v-slot:item.contractor_order_id="{ item }">
        <v-list class="bg-transparent" dense>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title>{{ moment.utc(item.created_at, 'DD.MM.YYYY HH:mm').local().format('DD.MM.YYYY HH:mm') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0" v-if="item.contractor_order_id">
            <v-list-item-content>
              <v-list-item-title>GT {{ item.contractor_order_id }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
      <template v-slot:item.route="{ item }">
        <v-list class="bg-transparent list-route" dense v-if="item.address_point_a && item.address_point_b">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title><v-icon class="mr-3">fa-street-view</v-icon> {{ item.address_point_a }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title><v-icon class="mr-3">fa-flag-checkered</v-icon> {{ item.address_point_b }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list class="bg-transparent list-route" dense else>
          <template v-for="(itemRoute, index) in item.route">
            <v-list-item class="px-0" v-if="itemRoute.fullname && index === 0" :key="index">
              <v-list-item-content>
                <v-list-item-title><v-icon class="mr-3">fa-street-view</v-icon> {{ itemRoute.fullname }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-0" v-if="itemRoute.fullname && index === Object.keys(item.route).length - 1" :key="index">
              <v-list-item-content>
                <v-list-item-title><v-icon class="mr-3">fa-flag-checkered</v-icon> {{ itemRoute.fullname }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </template>
      <template v-slot:item.driver="{ item }">
        <v-list class="bg-transparent" dense>
          <v-list-item class="px-0" >
            <v-list-item-content v-if="item.driver && item.driver.name">
              <v-list-item-title>{{ item.driver.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0" v-if="item.vehicle && item.vehicle.model">
            <v-list-item-content>
              <v-list-item-title>{{ item.vehicle.model }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0" v-if="item.vehicle && item.vehicle.plates">
            <v-list-item-content>
              <v-list-item-title>{{ item.vehicle.plates }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
      <template v-slot:item.agent_order_id="{ item }">
        <v-list class="bg-transparent" dense v-if="item.agent_order_id">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title>{{ item.agent_name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title>{{ item.agent_order_id }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
      <template v-slot:item.comment="{ item }">
        <v-dialog dark v-if="item.comment" width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="info" v-bind="attrs" v-on="on">
              <v-icon>fa-info-circle</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="text-h5">Notes</v-card-title>
            <v-divider/>
            <v-card-text class="py-5">
              {{ item.comment }}
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:item.status="{ item }">
        <v-btn text :to="{name: 'trip', params: {id: item.id}}">
          {{ item.status }}
        </v-btn>
      </template>

    </v-data-table>
    <v-snackbar v-model="agentDiscountUploadSuccess" timeout="5000" right bottom color="green" elevation="24" class="mb-3">Agent discounts successfully updated!</v-snackbar>
    <v-snackbar v-model="agentDiscountUploadError" timeout="5000" right bottom color="red" elevation="24" class="mb-3">{{ agentDiscountUploadErrorMessage }}</v-snackbar>
  </v-container>
</template>

<script>
import axios from '@/axios'
import moment from 'moment'
import _ from 'lodash'
// import UploadButton from '@/components/UploadButton.vue'

export default {
  name: 'Dashboard',
  // components: { UploadButton },
  data: () => ({
    loading: true,
    checkReportInterval: null,
    reportLoading: false,
    numberOfPages: 0,
    totalCollection: 0,
    collection: [],
    options: {},
    filter: {},
    dialogPickerHeaders: false,
    menuPickerStart: false,
    menuPickerEnd: false,
    selectedHeaders: [],
    agentDiscountUploading: false,
    agentDiscountUploadSuccess: false,
    agentDiscountUploadError: false,
    agentDiscountUploadErrorMessage: false
  }),
  watch: {
    options: {
      async handler () {
        await this.changeData()
      }
    },
    'filter.search': {
      handler () {
        this.changeData()
      }
    },
    'filter.tariffZone': {
      handler () {
        this.changeData()
      }
    },
    'filter.statuses': {
      handler () {
        this.changeData()
      }
    },
    'filter.userTypes': {
      handler () {
        this.changeData()
      }
    },
    'filter.rideTypes': {
      handler () {
        this.changeData()
      }
    },
    'filter.classes': {
      handler () {
        this.changeData()
      }
    },
    'filter.legalEntities': {
      handler () {
        this.changeData()
      }
    },
    'filter.datePickerStart': {
      handler () {
        this.changeData()
      }
    },
    'filter.addressPointA': {
      handler () {
        this.changeData()
      }
    },
    'filter.addressPointB': {
      handler () {
        this.changeData()
      }
    },
    'filter.vehiclePlates': {
      handler () {
        this.changeData()
      }
    },
    'filter.driver': {
      handler () {
        this.changeData()
      }
    },
    deep: true
  },
  methods: {
    changeData () {
      if (this.storePaginationSort !== this.options) {
        this.$store.dispatch('orderPaginationSort', this.options)
      }

      if (this.storeFilter !== this.filter) {
        this.$store.dispatch('orderFilter', this.filter)
      }

      this.callFetchData()
    },
    callFetchData: _.debounce(function () {
      this.fetchData()
    }, 100),
    getDataForOrders () {
      const paginationSortOptions = this.storePaginationSort

      return {
        rowsPerPage: paginationSortOptions.itemsPerPage,
        tz: new Date().getTimezoneOffset(),
        sortBy: paginationSortOptions.sortBy,
        sortDesc: paginationSortOptions.sortDesc,
        filter: this.storeFilter
      }
    },
    async fetchData () {
      this.loading = true
      // Sort and pagination
      const paginationSortOptions = this.storePaginationSort
      // URL
      const url = `orders?page=${paginationSortOptions.page}`
      // Get collection
      await axios.post(url, this.getDataForOrders()).then(response => {
        this.loading = false
        this.collection = response.data.data
        this.totalCollection = response.data.total
        this.numberOfPages = response.data.to
      }).catch(error => {
        console.log(error)
        alert('Error: see in console')
      })
    },
    callInitiateCsvReport: _.debounce(async function () {
      await this.initiateCsvReport()
    }, 100),

    async checkReportStatus (id) {
      try {
        const { data: { status, payload } } = await axios.get(`orders/csv/status/${id}`)

        if (status === 'OK') {
          if (payload.status === 'complete') {
            window.open(payload.downloadUrl, '_blank')
            /* .focus() */
            clearInterval(this.checkReportInterval)
            this.reportLoading = false
            return true
          }
        }
      } catch (error) {
        console.log(error)
        alert('Error: see in console')
      }
    },
    async initiateCsvReport () {
      if (this.storePaginationSort !== this.options) {
        await this.$store.dispatch('orderPaginationSort', this.options)
      }

      if (this.storeFilter !== this.filter) {
        await this.$store.dispatch('orderFilter', this.filter)
      }

      const paginationSortOptions = this.storePaginationSort

      try {
        this.reportLoading = true
        let timezone = null

        if (window.Intl) {
          timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        }

        const { data: { status, request_id: requestId } } = await axios.post(`orders/csv?page=${paginationSortOptions.page}`, {
          ...this.getDataForOrders(),
          columns: this.showHeaders?.map(({ value }) => value),
          timezone
        })

        if (status === 'OK') {
          if (!(await this.checkReportStatus(requestId))) {
            this.checkReportInterval = setInterval(async () => {
              await this.checkReportStatus(requestId)
            }, 2000)
          }
        }
      } catch (error) {
        this.reportLoading = false
        console.log(error)
      }
    },
    changeColorFilter (obj) {
      return obj && obj.length > 0 ? 'accent' : 'default'
    },
    async onAgentDiscountFileChoice (e) {
      const file = e.target.files[0]

      if (file) {
        this.agentDiscountUploading = true

        try {
          // Get collection
          const formData = new FormData()
          formData.append('file', file)
          const { data: { status } } = await axios.post('agent/discounts/import', formData)
          if (status === 'OK') {
            this.agentDiscountUploadSuccess = true
          }
        } catch ({ data }) {
          if (data && data.errors) {
            const errors = Object.values(data.errors)

            this.agentDiscountUploadErrorMessage = errors[0][0]
            this.agentDiscountUploadError = true
          }
        } finally {
          this.agentDiscountUploading = false
        }
      }
    }
  },
  computed: {
    showHeaders () {
      return this.headers.filter(s => this.selectedHeaders.includes(s))
    },
    headers () {
      const columns = [
        {
          text: 'Order ID',
          value: 'contractor_order_id'
        },
        {
          text: 'Route',
          value: 'route'
        },
        {
          text: 'Agent ID',
          value: 'agent_order_id'
        },
        {
          text: 'Driver / Fleet',
          value: 'driver'
        },
        {
          text: 'Class',
          value: 'class'
        },
        {
          text: 'Price',
          value: 'price_raw'
        },
        {
          text: 'Notes',
          value: 'comment'
        },
        {
          text: 'Order Type',
          value: 'order_type'
        },
        {
          text: 'Status',
          value: 'status'
        }
      ]

      if (this.$store.state.auth.user.show_special_tariff) {
        columns.push({
          text: 'Special tariff',
          value: 'special_tariff'
        })
      }

      return columns
    },
    statuses () {
      return this.$store.state.statuses.items
    },
    classes () {
      return this.$store.state.classes.items
    },
    userTypes () {
      return this.$store.state.userTypes.items
    },
    dateStartFormatted () {
      return this.filter.datePickerStart ? moment(this.filter.datePickerStart).format('DD/MM/YYYY H:i') : ''
    },
    dateEndFormatted () {
      return this.filter.datePickerEnd ? moment(this.filter.datePickerEnd).format('DD/MM/YYYY H:i') : ''
    },
    storeFilter () {
      return this.$store.state.orders.orderFilter
    },
    storePaginationSort () {
      return this.$store.state.orders.orderPaginationSort
    }
  },
  async mounted () {
    this.selectedHeaders = this.headers
    this.options = this.$store.state.orders.orderPaginationSort
    this.filter = this.$store.state.orders.orderFilter
  }
}
</script>

<style lang="scss">
.bg-transparent {
  background: transparent !important;
}
</style>
